import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

import './Sketchbook.css'

function Description(props) {

	const title = props.title;
	const body = props.body;
	const extra = props.extra;
	const showIcon = props.showIcon;
	const onIconClick = props.onIconClick;

	return (
		<div className='description'>
			{title ?
				<div className='title'>
					{showIcon ?
						<img className='icon' src='res/Pencil_Black.svg' onClick={onIconClick}/>
						: null}
					<p dangerouslySetInnerHTML={{ __html: title }}></p>
				</div>
				: null}
			{body ?
				<div className='body'>{body}</div>
				: null}
			{extra ?
				<div className='extra'>{extra}</div>
				: null}
		</div>
	);
}

function Sketchbook(props) {

	const title = props.title;
	const body = props.body;
	const extra = props.extra;
	const imgOneUrl = props.imgOneUrl;
	const imgOneDetail = props.imgOneDetail
	const imgTwoUrl = props.imgTwoUrl;
	const imgTwoDetail = props.imgTwoDetail;
	const imgThreeUrl = props.imgThreeUrl;
	const imgThreeDetail = props.imgThreeDetail;
	const instagram = props.instagram
	const reverseColumns = props.reverseColumns ? 'reversed' : '';
	const showDescriptionIcon = props.showDescriptionIcon == null ? false : props.showDescriptionIcon;
	const onDescriptionIconClick = props.onDescriptionIconClick

	return (
		<div className={`sketchbook ${reverseColumns}`}>
			<Description
				title={title}
				body={body}
				extra={extra}
				showIcon={showDescriptionIcon}
				onIconClick={onDescriptionIconClick}/>
			{imgOneUrl || imgTwoUrl ? <div className='images'>
				<div className={`left-column`}>
					{imgOneUrl ?
						<div className='img-one-container'>
							<img src={imgOneUrl}></img>
							{imgOneDetail ?
								<p className='detail' dangerouslySetInnerHTML={{ __html: imgOneDetail }}></p>
								: null}
						</div> : null}
				</div>
				<div className={`right-column`}>
					{imgTwoUrl ?
						<div className='img-two-container'>
							{imgTwoDetail ?
								<p className='detail' dangerouslySetInnerHTML={{ __html: imgTwoDetail }}></p>
								: null}
							<img src={imgTwoUrl}></img>
						</div> : null}
				</div>
			</div> : null}
			{imgThreeUrl ?
				<div className='img-three-container'>
					<img className='img-three' src={imgThreeUrl}></img>
					{imgThreeDetail ?
						<p className='detail' dangerouslySetInnerHTML={{ __html: imgThreeDetail }}></p>
						: null}
				</div> : null}
			{instagram ?
				<div className={`instagram`}>
					<InstagramEmbed url="https://www.instagram.com/jillbryarsfigure" />
				</div> : null}
		</div>
	);

}

function DynamicSketchbook(props) {

	const descTitle = props.descTitle;
	const descBody = props.descBody;
	const descExtra = props.descExtra;
	const showDescIcon = props.showDescIcon == null ? false : props.showDescIcon;
	const onDescIconClick = props.onDescIconClick
	const imgInfos = props.imgInfos ? props.imgInfos : []
	const reverseColumns = props.reverseColumns ? 'reversed' : '';

	const leftImgInfos = imgInfos.filter((_, index) => index % 2 == 0);
	const rightImgInfos = imgInfos.filter((_, index) => index % 2 == 1);

	return (
		<div className={`sketchbook ${reverseColumns}`}>
			<Description
				title={descTitle}
				body={descBody}
				extra={descExtra}
				showIcon={showDescIcon}
				onIconClick={onDescIconClick}/>
			{descTitle ?
				<hr class="separator"/>
				: null}
			<div className='images'>
				<div className={`left-column`}>
					{leftImgInfos.map((imgInfo) => (
						<div className='img-container'>
							<img src={imgInfo.url}></img>
							{imgInfo.detail ?
								<p className='detail' dangerouslySetInnerHTML={{ __html: imgInfo.detail }}></p>
								: null}
						</div>
					))}
				</div>
				<div className={`right-column`}>
					{rightImgInfos.map((imgInfo) => (
						<div className='img-container'>
							<img src={imgInfo.url}></img>
							{imgInfo.detail ?
								<p className='detail' dangerouslySetInnerHTML={{ __html: imgInfo.detail }}></p>
								: null}
						</div>
					))}
				</div>
			</div>
		</div>
	);

}

export {Sketchbook, DynamicSketchbook};